import React, { useEffect, useState } from 'react';
import { i18nIntl } from '../../lib/ep';
import { injectIntl } from 'react-intl';
import { useCSS } from '../../lib/hooks';

import ActionButton, { SquaredButton } from '../builder/ActionButton';
import Spinner from '../builder/Spinner';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText';
import ButtonCollection from '../builder/ButtonCollection';

const MediaGalleryItemSelector = ({ items, ...props }) => {
	useCSS('comp/media_gallery_picker.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const max_items = props?.max_items ?? 2;	// "false" to disable
	const max_pages = props?.max_pages ?? 3;
	const title = props?.title ?? i18n("Select a post");
	const subtitle = props?.subtitle ?? false;
	const title_no_posts = props?.title_no_posts ?? i18n("No posts are available for selection.");
	const subtitle_no_posts = props?.subtitle_no_posts ?? false;

	const [ selected, setSelected ] = useState([]);
	const [ loading, setLoading ] = useState(props?.loading ?? false);

	useEffect(() => {
		if(props.loading == loading) return;

		setLoading(props.loading);
	}, [ props.loading ]);

	if(items == undefined) return null;

	const toggleSelectItem = (item) => {
		const _selected = [...selected];
		const index = (selected).findIndex(obj => obj.id === item.id);

		if(index === -1) {
			_selected.push(item);
		} else {
			_selected.splice(index, 1);
		}

		if(max_items !== false && max_items < _selected.length) return;

		setSelected(_selected)
	};

	let classes = ['gui_grid', 'cards_selector'];
	if(props._class != undefined) classes.push(props._class);

	if(loading) {
		return (
			<div class='is_loading'>
				<Spinner
					_class={{ other:'gui_pos_rel_important' }}
					force_bg={true}
					autotranslate={false}
				>{i18n("Loading posts")}...</Spinner>
			</div>
		)
	}

	if(items.length == 0) {
		return (
			<LeveledHTMLText>
				<h2 class="gui_force_bold in_bottom">{title_no_posts}</h2>

				{(subtitle_no_posts) && (
					<p
						class="gui_not_in_top_small"
						dangerouslySetInnerHTML={{ __html:subtitle_no_posts }}
					/>
				)}
			</LeveledHTMLText>
		)
	}

	let button_label = i18n("Confirm");
	if(max_items !== false) {
		button_label += ` (${selected.length} / ${max_items})`;
	}

	return (
		<div>
			<LeveledHTMLText
				_class={{ other:'gui_not_in_bottom' }}
			>
				<h1 class="gui_force_bold in_bottom">{title}</h1>

				{(subtitle) && (
					<p
						class="gui_not_in_top_small"
						dangerouslySetInnerHTML={{ __html:subtitle }}
					/>
				)}
			</LeveledHTMLText>

			<ul class="gui_media_gallery_picker">
				{items.map((item, i) => {
					const is_selected = selected.find((i) => (i.id == item.id));
					const is_disabled = !is_selected && selected.length >=max_items;
					const media_class = [`is_${item.type}`];
					if(is_selected) media_class.push('is_selected');
					if(is_disabled) media_class.push('is_disabled gui_remove_pointer_events');

					return (
						<li
							key={i}
							class={media_class.join(" ")}
							onClick={(!is_disabled) ? () => toggleSelectItem(item) : null}
						>
							<img
								class="image"
								src={item.picture}
								width="100%"
							/>
						</li>
					)
				})}
			</ul>

			{(props.prev_cursor || props.next_cursor) && (
				<nav class="gui_navigate_to_slide">
					<SquaredButton
						disabled={(!props.prev_cursor) ? true : false}
						color="transparent"
						icon='knk-arrow-l-big'
						_class={{ other:'go_prev' }}
						onClick={() => props.onPaginate(-1)}
						aria-label={i18n("Go previous page")}
					/>

					<SquaredButton
						disabled={(!props.next_cursor || props.page_number >= max_pages) ? true : false}
						color="transparent"
						icon='knk-arrow-r-big'
						_class={{ other:'go_next' }}
						onClick={() => props.onPaginate(1)}
						aria-label={i18n("Go next page")}
					/>
				</nav>
			)}

			<ButtonCollection
				_class={{ other:'flex_button gui_not_in_top' }}
			>
				<ActionButton
					_fullclass=""
					onClick={() => {
						props.onSelect(selected)
					}}
					disabled={selected.length == 0}
					autotranslate={false}
				>{button_label}</ActionButton>
			</ButtonCollection>
		</div>
	)
};

export default injectIntl(MediaGalleryItemSelector);